import React from 'react';
import { useHistory } from 'react-router-dom';

import { Button, Flex } from '@lucidhq/lucidium';

import { ROUTES } from '~/constants';
import { BasePage } from '~/impact-measurement/components';
import { IM_FLAGS } from '~/impact-measurement/constants';
import { useSplit } from '~/impact-measurement/hooks';
import { t } from '~/utils/i18n';

import { usePermissions } from '../Permissions/PermissionsProvider';
import { BackToStudiesDialog } from './BackToStudiesDialog';
import { CampaignDetailsStep } from './CampaignDetailsStep/CampaignDetailsStep';
import { useCampaignManager } from './CampaignManagerProvider';
import { CampaignManagerStepper } from './CampaignManagerStepper';
import { CampaignReviewStep } from './CampaignReviewStep/CampaignReviewStep';
import { ConnectCampaignDetailsStep } from './ConnectCampaignDetailsStep/ConnectCampaignDetailsStep';
import { MediaTrackingStep } from './MediaTrackingStep/MediaTrackingStep';
import { ServiceCampaignDetailsStep } from './ServiceCampaignDetailsStep/ServiceCampaignDetailsStep';
import { SurveyStep } from './SurveyStep/SurveyStep';
import { TargetAudienceStep } from './TargetAudienceStep/TargetAudienceStep';

export const CampaignManagerContainer = () => {
  const {
    steps: { DETAILS, MEDIA_TRACKING, REVIEW, AUDIENCE, SURVEY },
    activeStep,
    isService,
    isSoftware,
    isTrackingOnly
  } = useCampaignManager();
  const { isAdmin, isTrackingOnlyUser } = usePermissions();
  const history = useHistory();
  const { isOn } = useSplit(IM_FLAGS.CONNECT_TAG);

  if (isService && !isAdmin) {
    history.push(ROUTES.adminCampaigns);
  }

  return (
    <BasePage isFluid hasFooter={false}>
      <Flex lss={{ flexDirection: 'row', m: 'sm' }}>
        <BackToStudiesDialog>
          {({ onToggle }) => (
            <Button
              id="back-to-studies-trigger"
              onClick={onToggle}
              palette="secondary"
              emphasis="medium"
              type="button"
              lss={{ maxHeight: '2.5rem' }}
            >
              {t('backToStudiesDialog.triggerLabel')}
            </Button>
          )}
        </BackToStudiesDialog>
      </Flex>
      <CampaignManagerStepper />
      {isSoftware && DETAILS.id === activeStep && <CampaignDetailsStep />}
      {isService && DETAILS.id === activeStep && <ServiceCampaignDetailsStep />}
      {/* @TODO: remove the feature flag once all API integrations are completed */}
      {(isOn || isTrackingOnlyUser) &&
        isTrackingOnly &&
        DETAILS.id === activeStep && <ConnectCampaignDetailsStep />}
      {MEDIA_TRACKING.id === activeStep && <MediaTrackingStep />}
      {isSoftware && SURVEY.id === activeStep && <SurveyStep />}
      {isSoftware && AUDIENCE.id === activeStep && <TargetAudienceStep />}
      {REVIEW.id === activeStep && <CampaignReviewStep />}
    </BasePage>
  );
};
